import React, { useState } from "react";
import { MinigirdPatch, MinigridLocationEnriched } from "../../../../types/minigridtypes";
import styles from "./CreateUpdateMinigridFormView.module.scss";
import TextInput from "../../../../../../common/components/atom/TextInput/TextInput";
import MapComponent from "../../../../../../common/components/organisme/MapComponent/MapComponent";
import Button from "../../../../../../common/components/atom/Button/Button";
import { ValidationMingrid } from "../../../../utils/validationCheck";
import { FileItem } from "../../../../../../common/components/atom/InputFile/InputFile";
import FileListManager from "../../../../../../common/components/molecule/FileListManager/FileListManager";
import MomiSelector from "../../../../../momi/components/MomiSelector/MomiSelector";
import { Momi } from "../../../../../momi/types/momiTypes";
import MinigridLocationSelector from "../../../MinigridLocationSelector/MinigridLocationSelector";
import InstallationCodeLink from "../../../InstallationCode/InstallationCodeLink";
export interface CreateUpdateMinigridFormViewProps {
  data?: MinigirdPatch;

  labelSubmitBtn?: string;
  onSubmit?: () => void;
  onCancel?: () => void;
  isLoading?: boolean;
  error?: string;
  errorMessage?: string;
  successMessage?: string;
  setData?: (data: MinigirdPatch) => void;
  isErrorInput?: ValidationMingrid;
  setFile?: (file: FileItem) => void;
  setImages?: (images: File[]) => void;
  imageList?: File[] | undefined;
  currentMinigridId?: string | null;
  // Code déjà posé sur le site : affiché, jamais modifiable ici (un code
  // ne se corrige que par l'import de reprise, décision humaine).
  savedInstallationCode?: string | null;
  installationCodeError?: string;
}

export default function CreateUpdateMinigirdFormView({
  data,
  setData,
  labelSubmitBtn,
  onSubmit,
  isLoading,
  error,
  isErrorInput,
  setImages,
  imageList,
  currentMinigridId,
  savedInstallationCode,
  installationCodeError,
}: CreateUpdateMinigridFormViewProps) {
  const setDataFormated = (data: MinigirdPatch) => {
    if (setData) {
      return setData(data);
    }
  };

  const [location, setLocation] = useState<number[]>([0, 0]);
  const [selectedMomi, setSelectedMomi] = useState<Momi | null>(null);
  const [selectedLocations, setSelectedLocations] = useState<
    MinigridLocationEnriched[]
  >([]);

  const initLocationNames =
    data?.minigrid_linked_location_names && data.minigrid_linked_location_names.length > 0
      ? data.minigrid_linked_location_names
      : data?.minigrid_name
        ? [data.minigrid_name]
        : [];

  return (
    <div className={styles["container-form"]}>
      <p>{error}</p>
      <div
        className={[
          styles["container-form__item"],
        ].join(" ")}
      >
        <MinigridLocationSelector
          value={selectedLocations}
          onChange={(locs) => {
            setSelectedLocations(locs);
            setDataFormated({
              ...data,
              minigrid_linked_location_names: locs.map((l) => l.minigridName),
            });
          }}
          onUserSelect={(locs, added) => {
            const next: MinigirdPatch = {
              ...data,
              minigrid_linked_location_names: locs.map((l) => l.minigridName),
            };
            if (added && locs.length === 1) {
              setLocation([added.lattitude, added.longitude]);
              next.minigrid_name = added.minigridName;
              next.minigrid_location_lat = added.lattitude;
              next.minigrid_location_lng = added.longitude;
            }
            setDataFormated(next);
          }}
          initLocationNames={initLocationNames}
          currentMinigridId={currentMinigridId}
          label="Localisation minigrid à connecter"
        />
      </div>
      <div
        className={[
          styles["container-form__item"],
          styles["container-form__item--name"],
        ].join(" ")}
      >
        <TextInput
          label="Nom"
          value={data?.minigrid_name}
          onChange={(e) =>
            setDataFormated({ ...data, minigrid_name: e.target.value })
          }
          error={isErrorInput?.isErrorName}
        />
      </div>
      <div
        className={[
          styles["container-form__item"],
        ].join(" ")}
        data-testid="installation-code-field"
      >
        {savedInstallationCode ? (
          <p>
            Code installation : <InstallationCodeLink code={savedInstallationCode} />
            <br />
            <small>Un code posé ne se modifie pas ici (import de reprise, sur décision).</small>
          </p>
        ) : (
          <>
            <TextInput
              label="Code installation (MG|CI|SO-PAYS-NNNN)"
              placeholder="MG-BJ-0042"
              value={data?.minigrid_installation_code ?? ""}
              onChange={(e) =>
                setDataFormated({ ...data, minigrid_installation_code: e.target.value.toUpperCase() })
              }
              error={Boolean(installationCodeError)}
            />
            {installationCodeError && <small role="alert" id="installation-code-error">{installationCodeError}</small>}
          </>
        )}
      </div>
      <div
        className={[
          styles["container-form__item"],
          styles["container-form__item--description"],
        ].join(" ")}
      >
        <TextInput
          label="Description"
          value={data?.minigrid_description}
          rows={10}
          onChange={(e) =>
            setDataFormated({ ...data, minigrid_description: e.target.value })
          }
          error={isErrorInput?.isErrorDescription}
        />
      </div>
      <h2 className={styles["container-form__title-section"]}>Localisation</h2>

      <div
        className={[
          styles["container-form__section"],
          styles["container-form__section--location"],
        ].join(" ")}
      >
        <div>
          <div
            className={[
              styles["container-form__item"],
              styles["container-form__item--location"],
            ].join(" ")}
          >
            <TextInput
              label="Latitude"
              value={data?.minigrid_location_lat}
              onChange={(e) => {
                setLocation([
                  parseFloat(e.target.value),
                  data?.minigrid_location_lng || 0,
                ]);
                setDataFormated({
                  ...data,
                  minigrid_location_lat: parseFloat(e.target.value),
                });
              }}
              type="number"
              error={isErrorInput?.isErrorLocationLat}
            />
          </div>
          <div
            className={[
              styles["container-form__item"],
              styles["container-form__item--location"],
            ].join(" ")}
          >
            <TextInput
              label="Longitude"
              value={data?.minigrid_location_lng}
              onChange={(e) => {
                setLocation([
                  data?.minigrid_location_lat || 0,
                  parseFloat(e.target.value),
                ]);
                setDataFormated({
                  ...data,
                  minigrid_location_lng: parseFloat(e.target.value),
                });
              }}
              type="number"
              error={isErrorInput?.isErrorLocationLng}
            />
          </div>
        </div>

        <div
          className={[
            styles["container-form__item"],
            styles["container-form__item--map"],
          ].join(" ")}
        >
          {location && location[0] && location[1] ? (
            <MapComponent
              center={location}
              zoom={10}
              pinList={[{ position: location, name: "Minigrid" }]}
              style={{ height: "100%", width: "100%", borderRadius: "20px" }}
            />
          ) : (
            <></>
          )}
        </div>
      </div>

      <h2 className={styles["container-form__title-section"]}>EMS MoMi</h2>
      <div
        className={[
          styles["container-form__section"],
        ].join(" ")}
      >
        <div
          className={[
            styles["container-form__item"],
          ].join(" ")}
        >
          <MomiSelector
            value={selectedMomi}
            onChange={(momi: Momi | null) => {
              setSelectedMomi(momi);
              setDataFormated({
                ...data,
                minigrid_momi_id: momi?.momi_id || "",
              });
            }}
            initMomiId={data?.minigrid_momi_id}
            label="MoMi EMS"
          />
        </div>
      </div>

      <h2 className={styles["container-form__title-section"]}>Puissances</h2>
      <div
        className={[
          styles["container-form__section"],
          styles["container-form__section--location"],
        ].join(" ")}
      >
        <div
          className={[
            styles["container-form__item"],
            styles["container-form__item--location"],
          ].join(" ")}
        >
          <TextInput
            label="Onduleur kWc"
            value={data?.minigrid_inverter}
            onChange={(e) =>
              setDataFormated({
                ...data,
                minigrid_inverter: parseFloat(e.target.value),
              })
            }
            type="number"
            error={isErrorInput?.isErrorInverter}
          />
        </div>
        <div
          className={[
            styles["container-form__item"],
            styles["container-form__item--location"],
          ].join(" ")}
        >
          <TextInput
            label="Puissance kVA"
            value={data?.minigrid_power}
            onChange={(e) =>
              setDataFormated({
                ...data,
                minigrid_power: parseFloat(e.target.value),
              })
            }
            type="number"
            error={isErrorInput?.isErrorPower}
          />
        </div>
        <div
          className={[
            styles["container-form__item"],
            styles["container-form__item--location"],
          ].join(" ")}
        >
          <TextInput
            label="Capacité de batterie kWh"
            value={data?.minigrid_battery_capacity}
            onChange={(e) =>
              setDataFormated({
                ...data,
                minigrid_battery_capacity: parseFloat(e.target.value),
              })
            }
            type="number"
            error={isErrorInput?.isErrorBattery}
          />
        </div>
        <div
          className={[
            styles["container-form__item"],
            styles["container-form__item--location"],
          ].join(" ")}
        >
          <TextInput
            label="Groupe électrogène kVA"
            value={data?.minigrid_power_generator}
            onChange={(e) =>
              setDataFormated({
                ...data,
                minigrid_power_generator: parseFloat(e.target.value),
              })
            }
            type="number"
            error={isErrorInput?.isErrorPowerGenerator}
          />
        </div>
      </div>
      <div
        className={[
          styles["container-form__section"],
          styles["container-form__section--images"],
        ].join(" ")}
      >
        <div
          className={[
            styles["container-form__item"],
            styles["container-form__item--images"],
          ].join(" ")}
        >
          <FileListManager
            listFiles={imageList}
            setFileList={setImages}
            label="Image"
            messageEmpty="Aucune image"
            limitFiles={1}
            addLabel="Ajouter une image"
            accept="image/*"
            
          />
        </div>
      </div>

      <div className={styles["container-form__section"]}>
        <Button
          label={labelSubmitBtn}
          onClick={onSubmit}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
}
